import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { ModeTypes } from 'common/Enums'
import { ReactComponent as AvailableIcon } from 'assets/svg/shared/available.svg'
import { ReactComponent as UnavailableIcon } from 'assets/svg/shared/do_not_disturb.svg'
import { ReactComponent as ArrowDownIcon } from 'assets/svg/shared/arrow_down.svg'
import { useTranslation } from 'react-i18next'

export const ModeSelect = ({ toggleModal }) => {
    const { t } = useTranslation()
    const [availableText, setAvailableText] = useState(t('connectionstate.connecting'))
    const [iconAvailableState, setIconAvailableState] = useState(false)
    const { mode } = useSelector((state) => state.settings)

    useEffect(() => {
        switch (mode) {
            case ModeTypes.Available:
                setAvailableText(t('connectionstate.available'))
                setIconAvailableState(true)
                break
            case ModeTypes.Unavailable:
                setAvailableText(t('connectionstate.unavailable'))
                setIconAvailableState(false)
                break
            default:
                break
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode])

    return (
        <div onClick={toggleModal} className="settings__select d-flex justify-content-between">
            <div className="settings__select__status d-flex align-items-center">
                {iconAvailableState ? (
                    <AvailableIcon width={18} height={18} />
                ) : (
                    <UnavailableIcon width={18} height={18} />
                )}
                {availableText}
            </div>
            <ArrowDownIcon width={17} />
        </div>
    )
}
